<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JYkSGm/tc-custom/9781936535729.jpg?1724535314168" alt="This image is the cover for the book Night of the Living POTUS"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Night of the Living POTUS
      </h1>
      <p class="bookDescription body article font2">
        <p>HELL TO THE CHIEF<br/><br/>All United States Presidents have the same lesson to learn, and they all learn it early on the first full morning of their respective Administrations.<br/><br/>They are all confronted with the horrific secret at the heart of the White House...the one that subjects them to a blood-soaked, savage battle for survival.<br/><br/>To commemorate the 2012 election season, Hugo, Nebula and Stoker Nominee Adam-Troy Castro presents a newly-updated edition of one of his all-time strangest short stories, a one-of-a-kind mixture of political satire and relentless zombie horror that pits a new President against a siege by...the Founding Fiends.<br/><br/>Will Democracy survive...and what will be left of it?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Adam-Troy Castro
      </h2>
      
      <p class="authorDescription body article">Adam-Troy Castro's fiction has won the Seiun and Philip K. Dick Awards, and received two nominations for the Hugo, three for the Stoker, and eight for the Nebula.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?918dbc8a